/**
 * popup-js 2.0 by @thien.ho
 * License: MIT
 */
import Swiper from 'swiper';
import DOMPurify from 'dompurify';
import { Navigation, Pagination, Keyboard, A11y } from 'swiper/modules';
import CallBackLazy from './CallBackLazy.js';
import { getVimeoVideoId, getKalturaVideoId, trackingControlUI } from '../utils';
import ADA from './ADA.js';
import HandleControlVideoSwiper from './HandleControlVideoSwiper.js';

const callBack = new CallBackLazy();
export default class Popup {
  constructor(el) {
    this.$el = $(el);
    this.$openOpenPopup = $('.popup-is-open');
    this.classes = {
      widthContent: 'container',
      widthContentTmp: 'container',
      popupStatic: 'popup-static',
      popupShow: 'popup-show',
      closePopup: 'popup-is-close',
      noElement: 'no-element',
      isClick: 'is-click',
      adaBack: 'ada-back',
      adaNext: 'ada-next',
      swiperPaginationBullet: 'swiper-pagination-bullet',
      swiperPaginationBulletActive: 'swiper-pagination-bullet-active',
      swiperSlideActive: 'swiper-slide-active',
      zIndexOne: 'z-1',
    };
    this.elementClasses = {
      modPopup: '.mod-popup',
      closePopup: '.popup-is-close',
      popupContent: '.popup-content',
      popInner: '.popup-inner',
      btnRight: '.wrap-swiper-button-right',
      btnLeft: '.wrap-swiper-button-left',
      listGalleryPopup: '.list-gallery-popup',
      itemGalleryPopup: '.item-gallery-item',
      isClick: '.is-click',
      mark: '.mask-pop-overlay',
      btnSound: '.gallery-popup .btn-control-sound',
      btnPause: '.gallery-popup .btn-play-pause',
      videoYoutube: '.video-youtube',
      buttonNext: '.swiper-button-next',
      buttonPrev: '.swiper-button-prev',
      pagination: '.swiper-pagination',
      imageThumbSlideShow: '.image-thumb-slideshow',
      btnVideoMB: '.button-play-video-mb',
    };

    this.texts = {
      youtubeCom: 'youtube.com',
      youtuBe: 'youtu.be',
      vimeoCom: 'vimeo.com',
    };

    this.dom = {
      $html: $('html'),
      $clsPopupShow: `.popup-static`,
      $galleryPopup: $('.gallery-popup'),
      $videoGallery: $('.js-video-gallery'),
    };

    this.html = {
      closeContent: '<span class="icomoon icon-close"></span><span class="sr-only">Close Popup</span>',
      closeLink: `<button type="button" class="popup-is-close no-underline">
      <span class="icomoon icon-close"></span>
      <span class="sr-only">Close Popup</span>
      </button>`,
      contentInner: '<div class="popup-inner"><h3>The requested content cannot be loaded. <br> Please try again later.</h3></div>',

    };
    this.playerKaltura = null;
    this.flagLoad = false;
    this.swiperFirstFlag = false;
    this.handleControlVideoSwiper = new HandleControlVideoSwiper();
    window.listVideoPopup = [];
    window.swiperPopup = [];
    this.index = 1;
    this.adaInstance = new ADA();
    this.init();
  }

  init() {
    if (this.flagLoad === false && this.$el.length) {
      this.addListener();
      this.flagLoad = true;
    }
  }

  eventOpenPopupGalleryPauseAllVideo() {
    window.playerVideoGallery.forEach((player) => {
      player.pauseVideo();
    });
  }

  eventClosePopupGalleryPlayAllVideo() {
    window.playerVideoGallery.forEach((player) => {
      player.playVideo();
    });
  }

  addListener() {
    this.$openOpenPopup.on('click', this.openPopup.bind(this));
    this.dom.$html.on('click', this.elementClasses.closePopup, this.clickClosePopup.bind(this));
    this.dom.$html.on('click', this.elementClasses.mark, this.clickOutSite.bind(this));
    this.dom.$html.on('click', this.elementClasses.btnVideoMB, this.clickVideoPopupVideoMb.bind(this));

    this.dom.$html.on('click', this.elementClasses.btnPause, this.handlePauseVideoPopup.bind(this));
    this.dom.$html.on('click', this.elementClasses.btnSound, this.handleMuteVideoPopup.bind(this));

    $(window).keydown(this.keyBoardActionClose.bind(this));
    $(document).on('keyup keypress', this.keyBoardActionControl.bind(this));
    $(document).on('keydown', '[data-module="Popup"]', (event) => {
      if (event.target.tagName === 'BUTTON' || event.target.tagName === 'A') {
        this.handleTabPopup(event);
      }
    });
  }

  clickVideoPopupVideoMb(e) {
    const $swiperActive = $(e.currentTarget).parents('.swiper-slide-active');
    $swiperActive.find('.btn-play-pause').click();
  }

  handleTabPopup(event) {
    const { target, keyCode, shiftKey } = event;
    const $ele = $(target);
    const tabKeyCode = 9;
    const $popup = $('[data-module="Popup"]');
    const $popupButtonsAndLinks = $popup.find('button, a');
    const index = $popupButtonsAndLinks.index($ele);
    const indexButtonsAndLinksFirst = $popupButtonsAndLinks.index($popupButtonsAndLinks.first());

    if (keyCode === tabKeyCode && !shiftKey && $ele.hasClass('popup-is-close')) {
      event.preventDefault();
      $popupButtonsAndLinks.eq(0).focus();
    }

    if (index === indexButtonsAndLinksFirst && shiftKey && keyCode === tabKeyCode) {
      event.preventDefault();
      $popupButtonsAndLinks.last().focus();
    }
  }

  /**
   * Function
   */
  renderPopup() {
    const html = `<div class="mod-popup hello ${this.classes.popupShow}">
    <div class="popup-container inset-0 absolute">
    <div class="popup-content ${this.classes.widthContent}" aria-modal="true" role="dialog">
    <div class="mask-pop-overlay"></div>
    </div>
    </div>
    </div>`;
    $(document.body).append(html);
  }

  loadLazyOnLoad() {
    const $hasLazy = $('.popup-inner .lazy');
    if ($hasLazy.length) {
      $hasLazy.each((_index, el) => {
        const element = el;
        const elementTmp = $(element)[0].tagName;
        callBack.call(elementTmp, element);
      });
    }
  }

  convertToEmbed(url) {
    const urlYoutube = 'https://www.youtube.com/embed/';
    if (url.toLowerCase().indexOf(this.texts.youtubeCom) !== -1 && url.toLowerCase().indexOf('youtube.com/embed') === -1) {
      const tempV = url.split('?v=')[1];
      const v = tempV.split('&')[0];
      return `${urlYoutube + v}?autoplay=1&rel=0&showinfo=0`;
    }
    if (url.toLowerCase().indexOf('vimeo.com') !== -1 && url.toLowerCase().indexOf('player.vimeo.com/video') === -1) {
      const parts = url.split('/');
      const v2 = parts.pop();
      return `https://player.vimeo.com/video/${v2}?autoplay=1`;
    }
    if (url.toLowerCase().indexOf('youtu.be') !== -1) {
      const parts2 = url.split('/');
      const v3 = parts2.pop();
      return `${urlYoutube + v3}?autoplay=1&rel=0&showinfo=0`;
    }

    return url;
  }

  addMutedVideo(url) {
    if (url.toLowerCase().indexOf(this.texts.youtubeCom) === -1) {
      if (url.toLowerCase().indexOf('?') === -1) {
        return `${url}`;
      }
      return `${url}`;
    }
    return url;
  }

  popupVideo(ele) {
    let srcVideo = $(ele).attr('data-href');
    srcVideo = this.convertToEmbed(srcVideo);
    srcVideo = this.addMutedVideo(srcVideo);
    this.iframe = `<div class="popup-inner popup-video ">
              <div class="embed-responsive relative embed-responsive-16by9">
                <iframe title="Video lightbox" class="embed-responsive-item absolute inset-0 w-full h-full" src="${srcVideo}" frameborder="0"></iframe>
              </div>
              <div tabindex="0" class="ada-back"></div>
            </div>`;
    this.renderPopup();
    const $popupContent = $(this.dom.modPopup).find(this.elementClasses.popupContent);
    $popupContent.append(this.iframe);
    $popupContent.find(this.dom.popInner).append(this.html.closeLink);
  }

  popupContent(tmpContent) {
    let cloneTmp = '';
    cloneTmp = $(tmpContent).find(this.dom.popInner).clone();
    this.renderPopup();
    const $popupContent = $(this.dom.modPopup).find(this.elementClasses.popupContent);
    if ($(tmpContent).length) {
      $popupContent.append(cloneTmp);
    } else {
      $popupContent.addClass(this.classes.noElement).append(this.html.contentInner);
    }
    $popupContent.find(this.dom.popInner).append(this.html.closeLink);
  }

  openVideoPopup(nb) {
    window.listVideoPopup.forEach((_elem, i) => {
      if (nb === i) {
        this.checkOpenVideoNbOne(i);
      } else if (window.listVideoPopup[i] !== '') {
        this.checkOpenVideoNbElse(i);
      } else {
        // do nothing
      }
    });
  }

  checkOpenVideoNbOne(i) {
    if (window.listVideoPopup[i] !== '') {
      if (window.listVideoPopup[i].M !== 'player' && window.listVideoPopup[0].P !== 'player') {
        document.getElementById(window.listVideoPopup[i]).play();
      } else if (typeof window.listVideoPopup[i].playVideo !== 'undefined') {
        window.listVideoPopup[i].playVideo();
      } else {
        // do nothing
      }
    }
  }

  checkOpenVideoNbElse(i) {
    if (window.listVideoPopup[i].M !== 'player' && window.listVideoPopup[0].P !== 'player') {
      document.getElementById(window.listVideoPopup[i]).pause();
    } else if (typeof window.listVideoPopup[i].pauseVideo !== 'undefined') {
      window.listVideoPopup[i].pauseVideo();
    } else {
      // do nothing
    }
  }

  setupPopupGallery(indexInit) {
    const $item = $(this.elementClasses.itemGalleryPopup);
    $item.each((i, el) => {
      $(el).find('img').removeAttr('loading');
      if (!$(el).hasClass('clone-slide')) {
        const $iframe = $(el).find(this.elementClasses.videoYoutube);
        if ($iframe.length > 0) {
          const url = $iframe.attr('data-src');
          if (url.indexOf(this.texts.youtubeCom) !== -1 || url.indexOf('youtu.be') !== -1) {
            this.index++;
            $iframe.attr('id', `ytb-Popup${this.index}`);
            const tempt = url.split('?')[0].split('/');
            this.apiYoutube(tempt, i, el, indexInit);
          }
          if (url.toLowerCase().indexOf('vimeo.com') !== -1) {
            this.index++;
            $iframe.attr('id', `vimeo${this.index}`);
            const vimeoVideoId = getVimeoVideoId(url);
            this.apiVimeo(vimeoVideoId, el);
          }
          if (url.toLowerCase().indexOf('kaltura.com') !== -1) {
            this.index++;
            $iframe.attr('id', `kaltura-${this.index}`).attr('data-kaltura', this.index);
            const kalturaVideoId = getKalturaVideoId(url);
            this.apiKaltura(kalturaVideoId, url, el, $iframe);
          }
        } else {
          $(el).addClass('no-video');
        }
      } else {
        $(el).addClass('no-video');
      }
    });
  }

  apiKaltura(kalturaVideoId, _url, _el, $iframe) {
    /* eslint-disable */
    try {
      const player = window.KalturaPlayer.setup({
        targetId: $iframe.attr('id'),
        logLevel: 'OFF',
        plugins: true,
        playback: {
          autoplay: false,
          controls: false,
          muted: $(window).width() > 1199 ? false : true,
          loop: true,
          playsinline: true,
          allowMutedAutoPlay: true,
        },
        provider: {
          partnerId: window.HONDA_KALTURA_SETTINGS.partnerId,
          uiConfId: window.HONDA_KALTURA_SETTINGS.playerId
        },
      });
      player.loadMedia({entryId: kalturaVideoId});
      window.listVideoPopup.push(player);
    } catch (error) {
      console.log('Error: ', DOMPurify.sanitize(error));
    }

    /* eslint-enable */
  }

  apiYoutube(tempt, _i, el) {
    const player = new window.YT.Player(`ytb-Popup${this.index}`, {
      height: '900',
      width: '900',
      videoId: tempt[tempt.length - 1],
      playerVars: {
        playlist: tempt[tempt.length - 1],
        autohide: 1,
        showinfo: 0,
        wmode: 'opaque',
        controls: 0,
        autoplay: 0,
        loop: 1,
        rel: 0,
        fs: 0,
        mute: $(window).width() > 1199 ? 0 : 1,
      },
      events: {
        onReady: (event) => {
          if ($(el).hasClass(this.classes.swiperSlideActive)) {
            event.target.playVideo();
          }
          $(event.target).attr('tabindex', '-1');
        },
        onStateChange: (e) => {
          if (e.data === window.YT.PlayerState.PLAYING) {
            $(el).find(this.elementClasses.imageThumbSlideShow).removeClass(this.classes.zIndexOne);
          }
        },
      },
    });
    window.listVideoPopup.push(player);
  }

  apiVimeo(vimeoVideoId, el) {
    const player = new window.Vimeo.Player(`vimeo${this.index}`, {
      id: vimeoVideoId,
      autoplay: false,
      loop: true,
      muted: ($(window).width() <= 1199),
      controls: false,
    });
    player.ready().then(() => {
      $(player.element).removeAttr('frameborder');
      $(player.element).attr('tabindex', '-1');
      if ($(el).hasClass(this.classes.swiperSlideActive)) {
        player.play();
      }
    });
    player.on('play', () => {
      $(el).find(this.elementClasses.imageThumbSlideShow).removeClass(this.classes.zIndexOne);
    });
    window.listVideoPopup.push(player);
  }

  popupGallery(ele) {
    $(this.dom.$clsPopupShow).addClass('slider-gallery slider-dot-white');
    const index = $(ele).attr('data-index');
    const $list = $(this.dom.$clsPopupShow).find(this.elementClasses.listGalleryPopup);
    $list.each((_i, el) => {
      $(this.elementClasses.closePopup).css('opacity', 0);
      if (!$(el).hasClass('swiper-initialized')) {
        this.setupPopupGallery(index);
        const swiper = new Swiper(el, {
          modules: [Navigation, Pagination, Keyboard, A11y],
          slidesPerView: 1,
          initialSlide: Number(index) + 1,
          speed: 700,
          keyboard: {
            enabled: true,
          },
          a11y: true,
          navigation: {
            nextEl: $(el).find(this.elementClasses.buttonNext)[0],
            prevEl: $(el).find(this.elementClasses.buttonPrev)[0],
          },
          pagination: {
            el: $(el).find(this.elementClasses.pagination)[0],
            clickable: true,
          },
          on: {
            init: () => {
              $(el).find(this.elementClasses.itemGalleryPopup).find('*').attr('tabindex', '-1');
              $(el).find(`.${this.classes.swiperSlideActive}`).find('button, a, input').attr('tabindex', '0');
              $(el).find(`.${this.classes.swiperSlideActive}`).find('iframe').attr('tabindex', '-1');
              if ($(window).width() < 1200) {
                $(el).find('.active-sound').removeClass('active-sound');
              }
              this.adaInstance.removeAttrAriaDisabled(el);
              this.changeNumberBullet(el);
            },
            slideChange: (e) => {
              $(e.el).find(`.${this.classes.swiperPaginationBullet}`).removeClass(this.classes.swiperPaginationBulletActive);
              $(e.el).find(`.${this.classes.swiperPaginationBullet}`).eq(e.activeIndex).addClass(this.classes.swiperPaginationBulletActive);
              setTimeout(() => {
                if (swiper.activeIndex === 0) {
                  swiper.slideTo(swiper.slides.length - 2, 0, false);
                }
                if (swiper.activeIndex === swiper.slides.length - 1) {
                  swiper.params.speed = 0;
                  swiper.slideTo(1, 0, false);
                  setTimeout(() => {
                    swiper.params.speed = 700;
                  }, 10);
                }
                this.changeTimeOutSlide();
              }, 700);
            },
            transitionEnd: (e) => {
              $(el).find(this.elementClasses.itemGalleryPopup).find('*').attr('tabindex', '-1');
              $(el).find(`.${this.classes.swiperSlideActive}`).find('button, a, input').attr('tabindex', '0');
              $(el).find(`.${this.classes.swiperSlideActive}`).find('iframe').attr('tabindex', '-1');
              this.adaInstance.removeAttrAriaDisabled(el);
              this.changeNumberBullet(el);
              this.endTransitionSlide(e);
            },
          },
        });
        this.adaInstance.removeAttrAriaDisabled(el);
        window.swiperPopup.push(swiper);
      }

      setTimeout(() => {
        $(this.elementClasses.closePopup).css('opacity', '');
        window.swiperPopup[0].slideTo(Number(index) + 1, 0, false);
      }, 501);
    });
  }

  changeNumberBullet (elm) {
    const $bullet = $(elm).find('.swiper-pagination-bullet');
    const ariaLabel = 'aria-label';
    $bullet.each((i, el) => {
      $(el).attr(ariaLabel, `Go To Slide ${i}`);
      if (i === 0) {
        $(el).attr(ariaLabel, 'Go To Slide Clone');
      }
      if (i === $bullet.length - 1) {
        $(el).attr(ariaLabel, 'Go To Slide Clone');
      }
    });
  }

  changeTimeOutSlide() {
    this.handleSlideChange(this.swiperFirstFlag ? 0 : 3000);
  }

  endTransitionSlide(e) {
    setTimeout(() => {
      this.handleControlVideoSwiper.handleVideoSwiper(e, this.swiperFirstFlag ? 0 : 3000);
      this.swiperFirstFlag = true;
    }, this.swiperFirstFlag ? 500 : 1500);
  }

  handleSlideChange(time) {
    const $iframe = $(this.elementClasses.itemGalleryPopup).find('iframe, .kaltura-player-container');
    if ($iframe.length) {
      $iframe.each((i, _el) => {
        const url = $($iframe[i]).attr('src');
        if (url) {

          if (url.indexOf(this.texts.youtubeCom) !== -1 || url.indexOf(this.texts.youtuBe) !== -1) {
            $($iframe[i])[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
          if (url.toLowerCase().indexOf(this.texts.vimeoCom) !== -1) {
            $($iframe[i])[0].contentWindow.postMessage('{"method":"pause"}', '*');
          }
        } else if ($(_el).hasClass('kaltura-player-container')) {
          setTimeout(() => {
            window.listVideoPopup[i].pause();
          }, time);
        } else {
          // do nothing
        }
      });
    }
  }

  updateYoutubeUrl(popupContentId, url) {
    $(popupContentId).find(this.elementClasses.videoYoutube).attr('data-src', url);
  }

  openPopup(e) {
    const ele = e.currentTarget;
    const htmlClass = $(ele).data('htmlclass');
    const tmpContent = $(ele).data('id');
    const youtubeUrl = $(ele).data('youtube-url');
    const tmpPopup = $(ele).data('popup');
    const tmpWidthContent = $(tmpContent).data('content');
    const labelledby = $(ele).data('label');
    trackingControlUI($(ele), $(ele).attr('data-event-label'));
    window.scrollAgent.stop();
    if (youtubeUrl && $(tmpContent).length) {
      this.updateYoutubeUrl(tmpContent, youtubeUrl);
    }
    $(ele).addClass(this.classes.isClick);
    this.loadLazyOnLoad();
    if ($(tmpContent).hasClass('mod-popup-static')) {
      $(tmpContent).addClass(this.classes.popupStatic);
      if (tmpPopup === 'gallery') {
        this.eventOpenPopupGalleryPauseAllVideo();
        this.popupGallery(ele);
      }

    } else {
      if (typeof tmpWidthContent !== 'undefined') {
        this.classes.widthContent = tmpWidthContent;
      }

      if (tmpPopup === 'video') {
        this.popupVideo(ele);
      } else {
        this.popupContent(tmpContent);
      }
    }
    if ($(tmpContent).hasClass(this.classes.popupStatic)) {
      $(tmpContent).addClass(this.classes.popupShow);
    } else {
      $(this.dom.modPopup).addClass(this.classes.popupShow).find(this.elementClasses.popupContent).attr('aria-labelledby', labelledby);
    }
    this.dom.$html.addClass(htmlClass).addClass('popup-open');
    setTimeout(() => {
      this.dom.$html.addClass('popup-animation');
      $(`.${this.classes.popupShow}`).find('ada-next,a,button,.focus-div,.focus-item').eq(0).focus();
    }, 500);
    // callBack()
    return false;
  }

  closePopup() {
    this.handleMuteVideoClosePopup();
    const classHtml = this.dom.$html.find(this.elementClasses.isClick).data('htmlclass');
    this.dom.$html.removeClass(`popup-open popup-animation ${classHtml}`);
    if (this.dom.$html.find(`.${this.classes.popupShow}`).hasClass(this.classes.popupStatic)) {
      this.dom.$html.find(`.${this.classes.popupStatic}`).removeClass(this.classes.popupShow);
    } else {
      $(this.dom.modPopup).remove();
    }
    this.dom.$html.find(this.elementClasses.isClick).focus();
    this.dom.$html.find(this.elementClasses.isClick).removeClass(this.classes.isClick);
    this.classes.widthContent = this.classes.widthContentTmp;
    this.eventClosePopupGalleryPlayAllVideo();
    window.scrollAgent.start();
  }

  handleMuteVideoClosePopup() {
    const $swiperActive = $('.gallery-popup').find('.swiper-slide-active');
    const $soundActive = $swiperActive.find('.btn-control-sound');
    if ($soundActive.length && $soundActive.hasClass('active-sound')) {
      $soundActive.trigger('click');
    }
  }

  clickClosePopup() {
    this.closePopup();
  }

  clickOutSite() {
    this.closePopup();
  }

  handlePauseVideoPopup(e) {
    this.handleControlVideoSwiper.eventClickButtonPlayPauseVideo(e);
  }

  handleMuteVideoPopup(e) {
    this.handleControlVideoSwiper.eventClickButtonMuteUnmuteVideo(e);
  }

  keyBoardActionClose (e) {
    if (
      (e.keyCode === 27 && $(this.dom.$clsPopupShow).length) ||
      (e.keyCode === 13 && $(e.target).hasClass(this.classes.closePopup))
    ) {
      e.preventDefault();
      this.closePopup();
    }
  }

  keyBoardActionControl (e) {
    if ($(e.target).hasClass(this.classes.adaBack)) {
      $(`.${this.classes.popupShow}`).find('ada-next,a,button,.focus-div,.focus-item').eq(0).focus();
    }
    if (window.swiperPopup) {
      if (e.keyCode === 37) {
        window.swiperPopup.slidePrev();
      }
      if (e.keyCode === 39) {
        window.swiperPopup.slideNext();
      }
    }
    if (e.shiftKey && e.keyCode === 9 && $(e.target).hasClass(this.classes.adaNext)) {
      $(this.elementClasses.closePopup).focus();
    }
  }
}
